import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore, useRoutesStore } from 'store';
import { SOFTWARE_MANAGEMENT_ROUTES } from '../../index';

interface IAccountNavigationOptions {
    accountUuid?: string;
}

interface IRaptorArtifactNavigator {
    toArtifactListingPage: (options: IAccountNavigationOptions) => void;
    toArtifactUploadPage: (options: IAccountNavigationOptions) => void;
}

export const useRaptorArtifactNavigator = (): IRaptorArtifactNavigator => {
    const navigate = useNavigate();
    const { isDPUAdmin } = useAuthStore();
    const routeStore = useRoutesStore();
    const artifactListRoute = routeStore.getRoute(SOFTWARE_MANAGEMENT_ROUTES.RAPTOR_ARTIFACTS);
    const artifactUploadRoute = routeStore.getRoute(SOFTWARE_MANAGEMENT_ROUTES.RAPTOR_ARTIFACTS_UPLOAD);

    const getAccountSearch = React.useCallback((accountUuid?: string): string | undefined => {
        if (!isDPUAdmin || !accountUuid) {
            return undefined;
        }

        return `?${new URLSearchParams({ accountUuid }).toString()}`;
    }, [isDPUAdmin]);

    return {
        toArtifactListingPage: React.useCallback(
            ({ accountUuid }): void => {
                navigate({
                    pathname: artifactListRoute.path,
                    search: getAccountSearch(accountUuid),
                });
            },
            [artifactListRoute.path, getAccountSearch, navigate],
        ),
        toArtifactUploadPage: React.useCallback(
            ({ accountUuid }): void => {
                navigate({
                    pathname: artifactUploadRoute.path,
                    search: getAccountSearch(accountUuid),
                });
            },
            [artifactUploadRoute.path, getAccountSearch, navigate],
        ),
    };
};
